import {
  CAN_TOUCH,
  CHANGE_STATE,
  MAXIMIZE_GUIDE,
  MINIMIZE_GUIDE,
  SHOW_AUTHENTICATION_DIALOG,
  HIDE_AUTHENTICATION_DIALOG,
} from './types';

export const setState = (newState) => ({
  type: CHANGE_STATE,
  payload: newState,
});

export const maximizeGuide = () => ({
  type: MAXIMIZE_GUIDE,
});

export const minimizeGuide = () => ({
  type: MINIMIZE_GUIDE,
});

export const canTouch = () => ({
  type: CAN_TOUCH,
});

export const showAuthenticationDialog = () => ({
  type: SHOW_AUTHENTICATION_DIALOG,
});

export const hideAuthenticationDialog = () => ({
  type: HIDE_AUTHENTICATION_DIALOG,
});
